import { Button, ButtonProps } from 'elements/inputs/button'
import { LinkProps, NavLinkProps } from 'react-router-dom'

import { NavRouteLink, RouteLink } from './route-link'

export const LinkButton = (props: LinkProps & ButtonProps) => {
  return <Button component={RouteLink} {...props} />
}

export const NavLinkButton = (props: NavLinkProps & ButtonProps) => {
  return <Button component={NavRouteLink} {...props} />
}
